// This is a utility component to use while migrating simple text fields to rich text fields

import { ContentfulRichTextBlock } from 'libs/contentful/props';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';

interface BackwardsCompatibleTextProps {
  text: string | undefined;
  richText?: ContentfulRichTextBlock;
}

const BackwardsCompatibleText = ({ text, richText }: BackwardsCompatibleTextProps) => {
  return richText ? <RichTextCopy copy={richText} /> : text;
};

export default BackwardsCompatibleText;
